// File: src/App.tsx
import React, { useEffect, useState } from "react";
import { api } from "./utils/api.ts";
import LoginPage from "./components/LoginPage.tsx";
import MapPage from "./components/MapPage.tsx";

function App() {
  const [user, setUser] = useState<any | null>(null);
  const [displayedUser, setDisplayedUser] = useState<any | null>(null);
  const [loading, setLoading] = useState(true);
  const [config, setConfig] = useState<Record<string, any> | null>(null);

  useEffect(() => {
    const checkSession = async () => {
      try {
        const res = await api.get("/api/session");
        setUser(res.data);
      } catch {
        setUser(null);
      } finally {
        setLoading(false);
      }
    };
    checkSession();
  }, []);

  const handleLogin = (userData: any) => {
    setUser(userData);
    setDisplayedUser(null);
  };

  const handleLogout = async () => {
    try {
      await api.post("/api/logout");
    } finally {
      setUser(null);
      setDisplayedUser(null);
      setConfig(null);
    }
  };

  if (loading) return <div>Loading session...</div>;

  return user ? (
    <MapPage
      user={user}
      displayedUser={displayedUser ?? user}
      onLogout={handleLogout}
      onSwitchUser={setDisplayedUser}
      config={config}
      setConfig={setConfig}
    />
  ) : (
    <LoginPage onLogin={handleLogin} />
  );
}

export default App;
